$(".rating-block").each(function (i,el) {
    let value = +$(el).attr("data-rating") / 5 * 100

    $(el).find(".rating__fill").css("width", `${value}%`)
    $(el).find(".rating-block__num").html($(el).attr("data-rating"))

    let stars = $(el).find(".rating")

    $(stars).mousemove(function (e) {
        let percent = e.offsetX / $(this).outerWidth() * 100;
        $(el).find(".rating__fill").css("width", `${percent}%`)
    })

    $(stars).mouseleave(function (e) {
        let value = +$(el).attr("data-rating") / 5 * 100
        $(el).find(".rating__fill").css("width", `${value}%`)
        $(el).find(".rating-block__num").html($(el).attr("data-rating"))
    })

    $(stars).click(function (e) {
        let percent = e.offsetX / $(this).outerWidth() * 100;
        $(el).attr("data-rating",(percent * 5 / 100).toFixed(1))
        $(el).find(".rating-block__num").html($(el).attr("data-rating"))
    })
})
